<template>
  <div id="buyerProfileSettingPage">
    <v-main class="overflow-hidden">
      <BackBar/>
      <div class="container-fluid px-1">
        <div class="row">
          <div class="col-12 col-md-6 mx-auto pt-0">
            <div class="row ">
              <div class="col-12">
                <div class="bg-white py-5 px-3 rounded-lg">
                  <i class="fa-solid fa-gear fa-2xl transform-icon-to-top"></i>
                  <span class="font16px mr-2 font-weight-bold">تنظیمات پروفایل کاربری</span>
                </div>
              </div>
              <div class="col-6 text-center font-weight-bold">
                <span :class="userInfoTab ? 'profile-active-tab':''" class="pointer" @click="showUserInfoTab">اطلاعات کاربری</span>
              </div>
              <div class="col-6 text-center font-weight-bold">
                <span :class="addressInfoTab ? 'profile-active-tab':''" class="pointer" @click="showAddressInfoTab">اطلاعات ارسال</span>
              </div>

            </div>
            <v-form v-if="userInfoTab" ref="form" class="row">
              <div class="col-8 col-md-7 text-left ">

                <input v-show="false" id="ImageFileUrl" ref="inputUpload"
                       name="ImageFileUrl" type="file"
                       @change="attachmentSelected">
                <v-avatar size="100">
                  <img v-if="selectedImage !== null" :src="selectedImage" alt="تصویر کاربر">
                  <i v-else class="fas fa-circle-user user-no-pic"></i>
                </v-avatar>
              </div>
              <div class="col-4 pr-0 ">
                <v-btn icon @click="$refs.inputUpload.click()"><i class="fa-solid fa-pen-to-square fa-2xl"></i></v-btn>
                <div class="pr-3">عکس مربع باشد</div>
              </div>
              <div class="col-6 pl-1 pb-1">
                <div class="mr-2 mb-2">نام *</div>
                <v-text-field v-model="firstName" :rules="MandatoryFieldRule" dense flat
                              solo>
                </v-text-field>
              </div>
              <div class="col-6 pr-1 pb-1">
                <div class="mr-2 mb-2">نام خانوادگی *</div>
                <v-text-field v-model="lastName" :rules="MandatoryFieldRule" dense flat solo>
                </v-text-field>
              </div>
              <div class="col-6 pl-1 py-1">
                <div class="mr-2 mb-2">شماره همراه(نام کاربری) *</div>
                <v-text-field v-model="phoneNumber" :rules="phoneNumberRules" dense flat solo>
                </v-text-field>
              </div>
              <div class="col-6 pr-1 py-1">
                <div class="mr-2 mb-2">کدملی</div>
                <v-text-field v-model="nationalCode" :rules="nationalCodeRules" dense flat solo type="number">
                </v-text-field>
              </div>
              <div class="col-12 py-1">
                <div class="mr-2 mb-2">پست الکترونیکی</div>
                <v-text-field v-model="email" :rules="emailRules" dense flat solo>
                </v-text-field>
              </div>
              <div class="col-12 py-1 mb-6">
                <div class="mr-2 mb-2">بیوگرافی</div>
                <editor-content :editor="userBioEditor" class="text-editor"/>
              </div>
              <div class="col-12 py-1 mb-6">
                <div class="mr-2 mb-2">نشانی(این نشانی در پروفایل درج میشود)</div>
                <editor-content :editor="userAddressEditor" class="text-editor"/>
              </div>
              <div class="col-12">
                <div class="mb-2">
                  نشانی خود را روی نقشه ثبت کنید
                </div>
                <div>
                  <v-btn class="loc-btn" icon @click="getCurrentLocation">
                    <i class="fas fa-location pl-1 white--text "></i>
                  </v-btn>
                  <GmapMap
                      ref="mapRef"
                      :center="myCoordinates"
                      :options='{ fullscreenControl: false, mapTypeControl: false }'
                      :zoom="zoom"
                      style="height:360px"
                      @click="mark">

                    <GmapMarker
                        v-for='(marker,index) in markers'
                        :key="index"
                        :animation="2"
                        :clickable="true"
                        :position="marker"
                        @click="center=marker"/>
                  </GmapMap>
                </div>
              </div>
              <div class="col-12 py-1">
                <div class="mr-2 mb-2">تلفن ثابت(در پروفایل درج میشود)</div>
                <v-text-field v-model="staticPhone" dense flat solo type="number">
                </v-text-field>
              </div>
              <div class="col-12 py-1">
                <div class="mr-2 mb-2">تلفن همراه(در پروفایل درج میشود)</div>
                <v-text-field v-model="phoneNumberShowInProfile" dense flat solo type="number">
                </v-text-field>
              </div>
              <div class="col-12 py-1">
                <div class="mr-2 mb-2">حوزه کاری خود را وارد کنید(در پروفایل درج میشود)</div>
                <v-text-field v-model="workField" dense flat solo>
                </v-text-field>
              </div>

              <div class="col-12">
                <v-btn block color="primary" @click="editUserInfo">
                  تایید
                </v-btn>
              </div>
            </v-form>
            <v-form v-if="addressInfoTab" ref="addressInfoForm">
              <div v-if="isDeliveryDataLoaded" class="row">
                <div class="col-6 pl-1 pb-1">
                  <div class="mr-2 mb-2">نام گیرنده *</div>
                  <v-text-field v-model="receiverName" :rules="MandatoryFieldRule" dense flat
                                solo>
                  </v-text-field>
                </div>
                <div class="col-6 pr-1 pb-1">
                  <div class="mr-2 mb-2">نام خانوادگی گیرنده *</div>
                  <v-text-field v-model="receiverFamily" :rules="MandatoryFieldRule" dense flat solo>
                  </v-text-field>
                </div>
                <div class="col-6 pl-1 pb-1">
                  <div class="mr-2 mb-2">شماره همراه گیرنده *</div>
                  <v-text-field v-model="receiverPhoneNumber" :rules="phoneNumberRules" dense flat
                                solo type="number">
                  </v-text-field>
                </div>
                <div class="col-6 pr-1 pb-1">
                  <div class="mr-2 mb-2">کد ملی گیرنده *</div>
                  <v-text-field v-model="receiverNationalCode" :rules="MandatoryFieldRule" dense
                                flat
                                solo>
                  </v-text-field>
                </div>
                <div class="col-12 py-1">
                  <div class="mr-2 mb-2">استان *</div>
                  <v-autocomplete v-model="provinceId" :items="provinceItems" :rules="MandatoryFieldRule" dense flat
                                  item-text="Text" item-value="Value" solo @change="findIndexSelectedCity">
                  </v-autocomplete>
                </div>
                <div class="col-12 py-1">
                  <div class="mr-2 mb-2">شهر *</div>
                  <v-autocomplete v-model="cityId" :items="cities" :rules="MandatoryFieldRule" dense flat
                                  item-text="Text"
                                  item-value="Value" solo>
                  </v-autocomplete>
                </div>
                <div class="col-12 py-1 mb-6">
                  <div class="mr-2 mb-2">نشانی(محل ارسال بار)*</div>
                  <editor-content :editor="sendAddressEditor" class="text-editor"/>
                  <div v-if="sendAddressEditor.getHTML() === '<p></p>'" class="font12px red--text mt-1">فیلد اجباری
                  </div>
                </div>
                <div class="col-4 pl-1">
                  <div class="mr-2 mb-2">کدپستی *</div>
                  <v-text-field v-model="zipCode" :rules="MandatoryFieldRule" dense flat solo>
                  </v-text-field>
                </div>
                <div class="col-4 px-1">
                  <div class="mr-2 mb-2">پلاک *</div>
                  <v-text-field v-model="pelak" :rules="MandatoryFieldRule" dense flat solo>
                  </v-text-field>
                </div>
                <div class="col-4 pr-1">
                  <div class="mr-2 mb-2">واحد *</div>
                  <v-text-field v-model="vahed" :rules="MandatoryFieldRule" dense flat
                                solo>
                  </v-text-field>
                </div>
                <div class="col-12">
                  <div class="mb-2">
                    نشانی محل ارسال خود را روی نقشه ثبت کنید
                  </div>
                  <div>
                    <v-btn class="loc-btn" icon @click="getCurrentLocationAddress">
                      <i class="fas fa-location pl-1 white--text "></i>
                    </v-btn>
                    <GmapMap
                        ref="mapRefAddress"
                        :center="myCoordinatesAddress"
                        :options='{ fullscreenControl: false, mapTypeControl: false }'
                        :zoom="zoom"
                        style="height:360px"
                        @click="markAddress">

                      <GmapMarker
                          v-for='(marker,index) in userAddressMarkers'
                          :key="index"
                          :animation="2"
                          :clickable="true"
                          :position="marker"
                          @click="center=marker"/>
                    </GmapMap>
                  </div>
                </div>
                <div class="col-12">
                  <v-btn block color="primary" @click="registerAddressInfo">
                    تایید
                  </v-btn>
                </div>
              </div>
            </v-form>
          </div>
        </div>
      </div>
    </v-main>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary">
      <div v-html="resultText"></div>

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import BackBar from "@/components/BackBar";
import {Editor, EditorContent} from 'tiptap';

export default {
  name: "BuyerProfileSetting",
  metaInfo: {
    title: 'ایوان خانه- تنظیمات پروفایل کاربری',
  },
  components: {BackBar, EditorContent,},
  data: () => ({
    isDeliveryDataLoaded: false,
    showLoaderDialog: false,
    showResult: false,
    resultText: '',
    userInfoTab: true,
    addressInfoTab: false,
    selectedImageFilePath: null,
    selectedImage: null,
    userBioEditor: null,
    userBio: '',
    userAddress: '',
    userAddressEditor: null,
    userAddressMarkers: [],
    userInfoMarkers: [],
    emailRules: [
      v => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return (pattern.test(v) || !v) || 'ایمیل نامعتبر'
      },
    ],
    nationalCodeRules: [
      v => (v.length == 10 || v.length == 0) || 'کد ملی 10 رقم است.',
    ],
    nationalCode: '',
    email: '',
    phoneNumberRules: [
      v => !!v || 'شماره موبایل اجباری است',
      value => (value && value[0] === "0") || 'اولین رقم موبایل با عدد صفر شروع می شود ',
      value => (value && value.length === 11) || 'شماره موبایل 11 رقم است.',
    ],
    phoneNumber: null,
    sendAddress: '',
    sendAddressEditor: null,
    firstName: null,
    lastName: null,
    staticPhone: null,
    phoneNumberShowInProfile: null,
    MandatoryFieldRule: [v => !!v || 'فیلد اجباری'],
    receiverName: '',
    receiverFamily: '',
    receiverPhoneNumber: '',
    receiverNationalCode: '',
    provinceItems: [],
    provinceId: '',
    cities: [],
    cityId: '',
    receiverLat: '',
    receiverLng: '',
    zipCode: '',
    address: '',
    pelak: '',
    vahed: '',
    appUserID: '',
    sendAddressNull: false,
    map: null,
    center: {lat: 45.508, lng: -73.587},
    myCoordinates: {
      lat: 35.723524,
      lng: 51.396660
    },
    zoom: 10,
    markers: [],
    myCoordinatesAddress: {
      lat: 35.723524,
      lng: 51.396660
    },
    workField: null,
    id: null,
    userName: null,
    isActive: null,
    password: null,
    hasPhoto: false,
  }),

  created() {
    this.$getLocation({})
        .then(coordinates => {
          this.myCoordinates = coordinates;
          this.markers.push(this.myCoordinates)
          this.myCoordinatesAddress = coordinates;
          if (this.userAddressMarkers.length > 0) {
            this.userAddressMarkers.pop()
            this.userAddressMarkers.push(this.myCoordinatesAddress)
          } else {
            this.userAddressMarkers.push(this.myCoordinatesAddress)
          }

        })
        .catch(error => console.log(error));
  },
  mounted() {
    this.getUserInfoData()
    this.getDeliveryData()
    // this.$refs.mapRef.$mapPromise.then(map => this.map = map);


  },
  methods: {
    mark(event) {
      if (this.markers.length > 0) {
        this.markers.pop()
        this.markers.push({lat: event.latLng.lat(), lng: event.latLng.lng()})
      } else {
        this.markers.push({lat: event.latLng.lat(), lng: event.latLng.lng()})
      }
    },
    markAddress(event) {
      if (this.userAddressMarkers.length > 0) {
        this.userAddressMarkers.pop()
        this.userAddressMarkers.push({lat: event.latLng.lat(), lng: event.latLng.lng()})
      } else {
        this.userAddressMarkers.push({lat: event.latLng.lat(), lng: event.latLng.lng()})
      }
    },
    getCurrentLocation() {
      this.$getLocation({})
          .then(coordinates => {
            this.myCoordinates = coordinates;
            if (this.markers.length > 0) {
              this.markers.pop()
              this.markers.push(this.myCoordinates)
              this.$refs.mapRef.$mapPromise.then(map => map.panTo(coordinates));

            } else {
              this.markers.push(this.myCoordinates)
            }
          })
          .catch(error => console.log(error));
    },
    getCurrentLocationAddress() {
      this.$getLocation({})
          .then(coordinates => {
            this.myCoordinatesAddress = coordinates;
            if (this.userAddressMarkers.length > 0) {
              this.userAddressMarkers.pop()
              this.userAddressMarkers.push(this.myCoordinatesAddress)
              this.$refs.mapRefAddress.$mapPromise.then(map => map.panTo(coordinates));

            } else {
              this.userAddressMarkers.push(this.myCoordinatesAddress)
            }
          })
          .catch(error => console.log(error));
    },
    showUserInfoTab() {
      this.addressInfoTab = false
      this.userInfoTab = true
    },
    showAddressInfoTab() {
      this.addressInfoTab = true
      this.userInfoTab = false
    },
    getUserInfoData() {
      this.showLoaderDialog = true

      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/Individual/_ClientProfile", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            let model = json.model
            let clientProfile = json.clientProfile
            this.selectedImage = model.FileUrl
            if (model.FileUrl !== null) {
              this.hasPhoto = true
            }
            this.firstName = model.Name
            this.lastName = model.Family
            this.phoneNumber = model.PhoneNumber
            this.email = model.Email===null ?'' :json.Email
            this.nationalCode = model.NationalCode === null ? '' : json.NationalCode
            this.userBioEditor = new Editor({
              content: clientProfile.Bio
            })
            this.userAddressEditor = new Editor({
              content: clientProfile.Address,
            })
            if (clientProfile.Latitude !== 0) {
              this.myCoordinates = {'lat': clientProfile.Latitude, 'lng': clientProfile.Longitude}
              if (this.markers.length > 0) {
                this.markers.pop()
                this.markers.push({'lat': clientProfile.Latitude, 'lng': clientProfile.Longitude})
              } else {
                this.markers.push({'lat': clientProfile.Latitude, 'lng': clientProfile.Longitude})
              }
            }
            this.staticPhone = clientProfile.StaticPhone
            this.phoneNumberShowInProfile = clientProfile.MobilePhone
            this.workField = clientProfile.WorkField
            this.id = model.ID
            this.userName = model.UserName
            this.isActive = model.IsActive
            this.password = model.Password
            this.showLoaderDialog = false

          })
          .catch(error => console.log('error', error));
    },
    editUserInfo() {
      this.$refs.form.validate()

      if (this.$refs.form.validate()) {
        this.showLoaderDialog = true
        let myHeaders = new Headers();
        myHeaders.append("Authorization", this.$getUserData().token);

        let formdata = new FormData();
        formdata.append("ID", this.id);
        formdata.append("UserName", this.userName);
        formdata.append("IsActive", this.isActive);
        formdata.append("Email", this.email);
        formdata.append("Password", this.password);
        formdata.append("ConfirmPassword", this.password);
        formdata.append("Name", this.firstName);
        formdata.append("Family", this.lastName);
        formdata.append("NationalCode", this.nationalCode);
        formdata.append("PhoneNumber", this.phoneNumber);
        formdata.append("TypeRole", "4");
        if (this.hasPhoto) {
          formdata.append("FileUrl", this.selectedImage);
        } else {
          formdata.append("ImageFileUrl", this.selectedImageFilePath);
        }

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };
        let resStatus = null
        fetch(this.$baseUrl + "ClientPanel/Individual/_IndividualProfile", requestOptions)
            .then(response => {
              resStatus = response.status
              return response.text()
            })
            .then(result => {
              if (resStatus === 200) {
                this.editClientProfile()
              } else {
                this.showLoaderDialog = false
                this.resultText = result
                this.showResult = true
              }
            })
            .catch(error => console.log('error', error));
      }
    },
    editClientProfile() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let formdata = new FormData();
      formdata.append("MobilePhone", this.phoneNumberShowInProfile);
      formdata.append("Address", this.userAddressEditor.getHTML());
      formdata.append("Bio", this.userBioEditor.getHTML());
      formdata.append("Latitude", this.markers[0].lat);
      formdata.append("Longitude", this.markers[0].lng);
      formdata.append("StaticPhone", this.staticPhone);
      formdata.append("WorkField", this.workField);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/Individual/_ClientProfile", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog=false
            this.resultText= result
            this.showResult= true
          })
          .catch(error => console.log('error', error));
    },
    getDeliveryData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/Individual/_IndividualDelivery", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.sendAddressEditor = new Editor({
              content: json.Address
            })
            this.zipCode = json.ZipCode;
            this.pelak = json.Plak;
            this.vahed = json.Vahed;
            this.receiverName = json.Name;
            this.receiverFamily = json.Family;
            this.receiverPhoneNumber = json.MobilePhone;
            this.receiverNationalCode = json.NationalCode;
            if (json.Latitude !== 0) {
              this.myCoordinatesAddress = {'lat': json.Latitude, 'lng': json.Longitude}
              if (this.userAddressMarkers.length > 0) {
                this.userAddressMarkers.pop()
                this.userAddressMarkers.push({'lat': json.Latitude, 'lng': json.Longitude})
              } else {
                this.userAddressMarkers.push({'lat': json.Latitude, 'lng': json.Longitude})
              }
            }
            this.appUserID = json.AppUserID;
            this.provinceId = json.ProvinceID;
            this.cityId = json.CityID;
            this.provinceItems = json.Provinces.filter(x => x.Disabled === false);
            this.findIndexSelectedCity()
            this.isDeliveryDataLoaded = true
            this.showLoaderDialog = false

          })
          .catch(error => console.log('error', error));
    },
    attachmentSelected(e) {
      let files = e.target.files;
      if (files.length > 0) {
        this.imageName = files[0].name
        if (this.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.selectedImage = fr.result
          this.selectedImageFilePath = files[0] // this is an image file that can be sent to server...
        })
      } else {
        this.selectedImage = null;
        this.selectedImageFilePath = null;
      }


    },
    findIndexSelectedCity() {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("ProvinceID", this.provinceId);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/LoadCities", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.cities = JSON.parse(result)
          })
          .catch(error => console.log('error', error));
    },
    registerAddressInfo() {
      this.$refs.addressInfoForm.validate()

      if (this.$refs.addressInfoForm.validate() && this.sendAddressEditor.getHTML() !== '<p></p>') {
        this.showLoaderDialog = true
        let myHeaders = new Headers();
        myHeaders.append("Authorization", this.$getUserData().token);
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        let urlencoded = new URLSearchParams();
        urlencoded.append("Address", this.sendAddressEditor.getHTML());
        urlencoded.append("ZipCode", this.zipCode);
        urlencoded.append("Plak", this.pelak);
        urlencoded.append("Vahed", this.vahed);
        urlencoded.append("Latitude", this.userAddressMarkers[0].lat);
        urlencoded.append("Longitude", this.userAddressMarkers[0].lng);
        urlencoded.append("Name", this.receiverName);
        urlencoded.append("Family", this.receiverFamily);
        urlencoded.append("MobilePhone", this.receiverPhoneNumber);
        urlencoded.append("NationalCode", this.receiverNationalCode);
        urlencoded.append("AppUserID", this.appUserID);
        urlencoded.append("ProvinceID", this.provinceId);
        urlencoded.append("CityID", this.cityId);

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };

        fetch(this.$baseUrl + "ClientPanel/Individual/_IndividualDelivery", requestOptions)
            .then(response => response.text())
            .then(result => {
              this.showLoaderDialog = false
              this.resultText = result
              this.showResult = true
            })
            .catch(error => console.log('error', error));
      }
    }
  }
}
</script>

<style scoped>

</style>
